const CURRENT_DATA = 
[
    {
        "id": 1,
        "type": "play",
        "title": "Fallout London",
        "url": "https://fallout4london.com",
    },
    {
        "id": 2,
        "type": "play",
        "title": "Echoes of the End",
        "url": "https://store.steampowered.com/app/2821610/Echoes_of_the_End_Enhanced_Edition/",
    },
    {
        "id": 3,
        "type": "play",
        "title": "Space Marine II",
        "url": "https://www.focus-entmt.com/en/games/warhammer-40000-space-marine-2",
    },
    {
        "id": 4,
        "type": "play",
        "title": "Pathfinder: Wrath of the Righteous",
        "url": "https://store.steampowered.com/app/1184370/Pathfinder_Wrath_of_the_Righteous__Enhanced_Edition/",
    },
    {
        "id": 5,
        "type": "play",
        "title": "Blue Prince",
        "url": "https://www.blueprincegame.com",
    },
    {
        "id": 6,
        "type": "read",
        "title": "Folklore, Myths, and Legends of Great Britain",
        "url": "https://www.themetropolitan.uk/p/folklore-myths-and-legends-of-britain",
    },
    {
        "id": 7,
        "type": "read",
        "title": "Illuminations",
        "url": "https://www.theguardian.com/books/2022/oct/14/illuminations-by-alan-moore-review-a-savaging-of-the-superhero-industry",
    },
    {
        "id": 8,
        "type": "read",
        "title": "Chief Seattle and the Town that Took His Name",
        "url": "https://www.penguinrandomhouse.com/books/554206/chief-seattle-and-the-town-that-took-his-name-by-david-m-buerge/",
    },
    {
        "id": 9,
        "type": "read",
        "title": "Hercules: The First Superhero",
        "url": "http://www.monasheemountainpublishing.com/index.html",
    },
    {
        "id": 10,
        "type": "read",
        "title": "The Book of Accidents",
        "url": "https://www.penguinrandomhouse.com/books/555274/the-book-of-accidents-by-chuck-wendig/",
    },
];

export default CURRENT_DATA;
